import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { deriveRoleFromEmail, useAuth } from "../context/AuthContext";

export default function RequireAuth({ children, requiredRole }) {
    const location = useLocation();
    const { user, loading, authEnabled, role, roleLoading, recoveryUser } = useAuth();
    const resolvedRole =
        role || user?.user_metadata?.role || deriveRoleFromEmail(user?.email || "");

    if (!authEnabled) {
        return children;
    }

    if (loading || (requiredRole && roleLoading)) {
        return (
            <div className="container" style={{ padding: "2rem" }}>
                <p>Checking your session...</p>
            </div>
        );
    }

    if (recoveryUser) {
        return <Navigate to="/auth/reset-password" replace />;
    }

    if (!user) {
        return <Navigate to="/auth" replace state={{ from: location }} />;
    }

    if (requiredRole && resolvedRole !== requiredRole) {
        return <Navigate to="/" replace />;
    }

    return children;
}
